'use client'

import { X24 } from '@vinted/monochrome-icons'
import {
  Button,
  Cell,
  Divider,
  Dialog,
  Navigation,
  Spacer,
  Text,
  BottomSheet,
} from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { useBreakpoint } from '@marketplace-web/breakpoints/breakpoints-feature'

type Props = {
  isOpen: boolean
  isBundleComplaint?: boolean
  isOpenedInDialog?: boolean
  onClose: () => void
}

const ComplaintRefundsOrderSavingsModal = ({
  isOpen,
  isOpenedInDialog = false,
  onClose,
  isBundleComplaint = true,
}: Props) => {
  const translate = useTranslate('complaint_refunds_item_discounts')
  const { phones } = useBreakpoint()
  const isMobileView = phones && !isOpenedInDialog

  const bodyTranslationKey = isBundleComplaint ? 'bundle_body' : 'single_item_body'

  const handleClose = () => onClose()

  const renderContent = () => {
    return (
      <>
        <Navigation
          body={translate('title')}
          right={
            <Button
              inline
              iconName={X24}
              styling={Button.Styling.Flat}
              onClick={handleClose}
              aria={{ 'aria-label': translate('a11y.close') }}
            />
          }
        />
        <Divider />
        <Cell>
          <Text as="span" text={translate(bodyTranslationKey)} />
          {!isMobileView && (
            <>
              <Spacer size={Spacer.Size.XLarge} />
              <Button
                text={translate('action')}
                styling={Button.Styling.Filled}
                onClick={handleClose}
              />
            </>
          )}
        </Cell>
      </>
    )
  }

  if (isMobileView) {
    return (
      <BottomSheet isVisible={isOpen} onClose={onClose}>
        {renderContent()}
      </BottomSheet>
    )
  }

  return (
    <Dialog show={isOpen} defaultCallback={onClose} closeOnOverlay>
      {renderContent()}
    </Dialog>
  )
}

export default ComplaintRefundsOrderSavingsModal
